module.exports = __webpack_public_path__ + "img/25.1ce4f337.jpg";